import React from 'react';
import { number, string, oneOfType, bool } from 'prop-types';

// Import components
import { VodSectionButton } from 'components/views/vod/components/buttons/VodSectionButton';
import { Container, Title } from './styles';

export const RegularHeader = ({
	title,
	sectionId,
	showAllMoviesButton,
	borderLine
}) => {
	return (
		<Container borderLine={borderLine}>
			<Title>{title}</Title>
			{showAllMoviesButton && (
				<VodSectionButton sectionId={sectionId} sectionTitle={title} />
			)}
		</Container>
	);
};

RegularHeader.defaultProps = {
	borderLine: false,
	showAllMoviesButton: false
};

RegularHeader.propTypes = {
	title: string.isRequired,
	sectionId: oneOfType([number, string]).isRequired,
	showAllMoviesButton: bool.isRequired,
	borderLine: bool
};
